<ng-container *ngIf="!!element">
    <hr [ngStyle]="separatorStyles" />
</ng-container>
